/**
 * Sub-navigation inside the /admin section. Mirrors the per-app AppTabs.
 */

import { NavLink } from 'react-router-dom';
import type { IconShield } from './Icons.js';
import {
  IconActivity,
  IconBolt,
  IconBot,
  IconPlug,
  IconRocket,
  IconSettings,
  IconUsers,
} from './Icons.js';

interface Tab {
  to: string;
  label: string;
  icon: typeof IconShield;
  end?: boolean;
}

const tabs: Tab[] = [
  { to: '/admin', label: 'Users', icon: IconUsers, end: true },
  { to: '/admin/apps', label: 'Apps', icon: IconRocket },
  { to: '/admin/tokens', label: 'Tokens', icon: IconPlug },
  { to: '/admin/usage', label: 'Usage', icon: IconBolt },
  { to: '/admin/agent-usage', label: 'Agent', icon: IconBolt },
  { to: '/admin/activity', label: 'Activity', icon: IconActivity },
  { to: '/admin/integrations', label: 'Integrations', icon: IconSettings },
  { to: '/admin/settings', label: 'Settings', icon: IconBot },
];

export function AdminTabs() {
  return (
    <nav
      aria-label="Admin sections"
      className="-mx-4 sm:-mx-6 px-4 sm:px-6 mb-8 border-b border-line"
    >
      <div className="flex items-center gap-1 overflow-x-auto pb-px">
        {tabs.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            {...(end ? { end: true } : {})}
            className={({ isActive }) =>
              'group relative flex items-center gap-1.5 px-3 py-2.5 text-sm font-medium whitespace-nowrap transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand/50 rounded-t-md ' +
              (isActive ? 'text-ink' : 'text-muted hover:text-ink')
            }
          >
            {({ isActive }) => (
              <>
                <Icon
                  size={14}
                  className={isActive ? 'text-brand' : 'text-faint group-hover:text-muted'}
                />
                <span>{label}</span>
                {isActive && (
                  <span
                    aria-hidden
                    className="absolute left-2 right-2 -bottom-px h-0.5 bg-brand rounded-full"
                  />
                )}
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
